import { render } from "./EmptyLayout.vue?vue&type=template&id=ac5cce94&scoped=true"
import script from "./EmptyLayout.vue?vue&type=script&lang=js"
export * from "./EmptyLayout.vue?vue&type=script&lang=js"

import "./EmptyLayout.vue?vue&type=style&index=0&id=ac5cce94&lang=less&scoped=true"

import exportComponent from "/builds/sqMDsSTzB/0/dsp/plazkart-interface/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ac5cce94"]])

export default __exports__